import { FormControlLabel, type FormControlLabelProps, styled } from '@mui/material';

interface RadioControlLabelProps extends FormControlLabelProps {
    checked: boolean;
}

export const StyledFormControlLabel = styled((props: RadioControlLabelProps) => <FormControlLabel {...props} />)(({ theme, checked }) => ({
    margin: '0',
    gap: '8px',
    '.MuiRadio-root': {
        padding: '0',
        svg: {
            fontSize: '1rem',
            color: checked ? theme.palette.secondary.main : 'inherit',
        },
    },
    '.MuiTypography-root': {
        ...theme.typography.body2,
        color: checked ? theme.palette.secondary.main : 'inherit',
        textTransform: 'capitalize',
    },
    '.MuiFormControlLabel-label': {
        color: 'inherit',
    },
}));
